import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { queryKeys } from './queryKeys';

const getDocsTopics = async () => {
  return await request.get(
    '/Docs/appeal_topics',
    null,
    'При получении списка тем произошла ошибка'
  );
};

const useDocsAppealTopicsQuery = (options) =>
  useQuery(queryKeys.appealopicsDocs(), getDocsTopics, options);

export default useDocsAppealTopicsQuery;
